var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-drag-drop.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { event } from "@adornis/chemistry/decorators/event.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
var XDragDrop = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => [{ ":host": { display: "flex" } }];
    this.disabled = false;
    this["child-selector"] = "*";
    this["key-attribute"] = "key";
    this["allow-from"] = ".handle";
    this["drag-mode"] = "freeMove";
    this.duplicate = false;
    this["dropzone-accept-selector"] = "ACCEPT_NOTHING";
    this["hold-time"] = void 0;
    this["degrees-on-move"] = 2;
    this.dragging = false;
    this.duplicateFn = () => {
    };
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.size === 1 && changedProperties.has("dragging"))
      return;
    if (this.disabled) {
      if (this._interactInstance)
        this._interactInstance.unset();
      if (this._dropzoneInteractable)
        this._dropzoneInteractable.unset();
      return;
    }
    const isBefore = (el1, el2) => {
      const bounding1 = el1.getBoundingClientRect();
      const bounding2 = el2.getBoundingClientRect();
      if (window.getComputedStyle(this).flexDirection === "row") {
        if (bounding1.top + bounding1.height / 2 < bounding2.top + bounding2.height / 2)
          return true;
        if (bounding1.top + bounding1.height > bounding2.top + bounding2.height * 1.5)
          return false;
        return bounding1.left + bounding1.width / 2 < bounding2.left + bounding2.width / 2;
      } else if (window.getComputedStyle(this).flexDirection === "column") {
        if (bounding1.left + bounding1.width / 2 < bounding2.left + bounding2.width / 2)
          return true;
        if (bounding1.left + bounding1.width > bounding2.left + bounding2.width * 1.5)
          return false;
        return bounding1.top + bounding1.height / 2 < bounding2.top + bounding2.height / 2;
      }
      throw new Error("USE DISPLAY:FLEX");
    };
    const self = this;
    let y = 0;
    let x = 0;
    let initialScrollTop;
    let initialScrollLeft;
    let initialPositions = [];
    let elementToMove;
    const autoScrollContainer = this.autoScrollOptions?.container ?? (typeof this.autoScrollContainer === "function" ? this.autoScrollContainer() : this.autoScrollContainer);
    if (this._interactInstance)
      this._interactInstance.unset();
    const interactjs = (await import("interactjs")).default.default;
    interactjs.dynamicDrop(true);
    this._interactInstance = interactjs(this["child-selector"], {
      context: this
    }).draggable({
      allowFrom: this["allow-from"],
      hold: this["hold-time"],
      manualStart: !!this["hold-time"],
      enabled: true,
      autoScroll: this.autoScrollOptions ?? {
        container: autoScrollContainer,
        margin: 100,
        distance: 5,
        interval: 10,
        speed: 1200
      },
      listeners: {
        start(e) {
          if (e.button !== 0)
            return;
          self.dragging = true;
          self.draggableChildren.forEach((el) => el.style.transition = "transform .21s ease");
          initialPositions = self.draggableChildren.map((el) => el.getBoundingClientRect());
          initialScrollTop = autoScrollContainer?.scrollTop;
          initialScrollLeft = autoScrollContainer?.scrollLeft;
          if (self.duplicate) {
            const boundingRect = e.target.getBoundingClientRect();
            elementToMove = e.target.cloneNode(true);
            elementToMove.style.position = "fixed";
            elementToMove.style.zIndex = "1";
            elementToMove.style.top = boundingRect.top + "px";
            elementToMove.style.left = boundingRect.left + "px";
            elementToMove.style.boxShadow = "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)";
            elementToMove.style.opacity = ".75";
            self.duplicateFn(e.target, elementToMove);
            document.body.appendChild(elementToMove);
          } else
            elementToMove = e.target;
          elementToMove.style.transform = `rotateZ(${self["degrees-on-move"] + "deg"}) scale(1.05)`;
        },
        move(e) {
          if (!self.dragging)
            return;
          y += e.dy;
          x += e.dx;
          const toTranslateX = x - (initialScrollLeft === void 0 ? 0 : initialScrollLeft - autoScrollContainer.scrollLeft);
          const toTranslateY = y - (initialScrollTop === void 0 ? 0 : initialScrollTop - autoScrollContainer.scrollTop);
          elementToMove.style.transform = self["drag-mode"] === "column" ? `translateY(${toTranslateY}px) translateZ(0) rotateZ(${self["degrees-on-move"]}deg) scale(1.05)` : self["drag-mode"] === "row" ? `translateX(${toTranslateX}px) translateZ(0) rotateZ(${self["degrees-on-move"]}deg) scale(1.05)` : `translate(${toTranslateX}px, ${toTranslateY}px) rotateZ(${self["degrees-on-move"]}deg) scale(1.05)`;
          elementToMove.style.transition = "none";
          elementToMove.style.zIndex = "1000";
          elementToMove.style.touchAction = "none";
          const currentSortingOrder = self.sortingOrder || [];
          const isBefores = self.draggableChildren.map((el) => isBefore(el, elementToMove));
          self.draggableChildren.forEach((el, i) => {
            if (el === elementToMove || self.duplicate)
              return;
            const aboveInCurrentOrder = currentSortingOrder.findIndex((x2) => x2 === el.getAttribute(self["key-attribute"])) < currentSortingOrder.findIndex((x2) => x2 === elementToMove.getAttribute(self["key-attribute"]));
            const isBeforeValue = isBefores[i];
            if (!isBeforeValue && aboveInCurrentOrder || isBeforeValue && !aboveInCurrentOrder) {
              const childToMove = initialPositions[!isBeforeValue && aboveInCurrentOrder ? i + 1 : i - 1];
              if (!childToMove)
                return;
              const currentBounding = initialPositions[i];
              el.style.transform = `translate(${childToMove.left - (currentBounding?.left ?? 0)}px, ${childToMove.top - (currentBounding?.top ?? 0)}px)`;
            } else
              el.style.transform = "translate(0, 0)";
          });
        },
        end(e) {
          if (!self.dragging)
            return;
          const stopImmediatePropagation = (e2) => e2.stopImmediatePropagation();
          const targetInteract = interactjs(e.target);
          targetInteract.on("click", stopImmediatePropagation, true);
          requestAnimationFrame(() => targetInteract.off("click", stopImmediatePropagation, true));
          self.dragging = false;
          const hoveredElement = self.draggableChildren.filter((el) => el !== elementToMove).filter((el) => !isBefore(el, elementToMove))[0];
          const idToInsertBefore = hoveredElement ? hoveredElement.getAttribute(self["key-attribute"]) : void 0;
          const newArray = self.sortingOrder.filter((id) => id !== elementToMove.getAttribute(self["key-attribute"])).filter((id) => !!id);
          newArray.splice(
            !idToInsertBefore ? newArray.length : newArray.findIndex((val) => val === idToInsertBefore),
            0,
            elementToMove.getAttribute(self["key-attribute"])
          );
          y = 0;
          x = 0;
          if (self.duplicate) {
            document.body.removeChild(elementToMove);
          } else {
            self.draggableChildren.forEach((el) => {
              el.style.transform = "translate(0, 0)";
              el.style.transform = "none";
              el.style.transition = "transform 0s ease";
              el.style.zIndex = "unset";
              el.style.touchAction = "unset";
            });
            self.dispatchEvent(
              new CustomEvent("resorted", {
                detail: {
                  order: newArray,
                  start: self.sortingOrder.findIndex((id) => id === elementToMove.getAttribute(self["key-attribute"])),
                  end: newArray.findIndex((element) => element === elementToMove.getAttribute(self["key-attribute"]))
                }
              })
            );
          }
          if (e.dropzone && e.dropzone !== self._dropzoneInteractable)
            self.dispatchEvent(new CustomEvent("dropped-elsewhere", { detail: e.target }));
        }
      }
    });
    if (this["hold-time"])
      this._interactInstance.on("hold", (event2) => {
        const interaction = event2.interaction;
        if (!interaction.interacting()) {
          interaction.start({ name: "drag" }, event2.interactable, event2.currentTarget);
        }
      });
    if (this._dropzoneInteractable)
      this._dropzoneInteractable.unset();
    this._dropzoneInteractable = interactjs(this, {
      context: this
    }).dropzone({
      accept: this["dropzone-accept-selector"],
      ondrop(e) {
        self.dispatchEvent(new CustomEvent("dropped", { detail: e.relatedTarget }));
        self.removeAttribute("dropenabled");
      },
      ondragenter(e) {
        self.setAttribute("dropenabled", "");
      },
      ondragleave(e) {
        self.removeAttribute("dropenabled");
      }
    });
  }
  get draggableChildren() {
    return Array.from(this.querySelectorAll(this["child-selector"]));
  }
  get sortingOrder() {
    return this.draggableChildren.map((child) => child.getAttribute(this["key-attribute"]));
  }
  render() {
    return html` <slot></slot> `;
  }
};
__decorateClass([
  property({ type: Boolean })
], XDragDrop.prototype, "disabled", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "child-selector", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "key-attribute", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "allow-from", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "drag-mode", 2);
__decorateClass([
  property({ type: Boolean })
], XDragDrop.prototype, "duplicate", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "dropzone-accept-selector", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "hold-time", 2);
__decorateClass([
  property()
], XDragDrop.prototype, "degrees-on-move", 2);
__decorateClass([
  event,
  state()
], XDragDrop.prototype, "dragging", 2);
XDragDrop = __decorateClass([
  customElement("x-drag-drop")
], XDragDrop);
export {
  XDragDrop
};
